export default __webpack_public_path__ + "static/media/2463.fb2ec673.png";